[
  { "inputs": [], "stateMutability": "nonpayable", "type": "constructor" },
  {
    "inputs": [
      { "internalType": "address", "name": "authority", "type": "address" }
    ],
    "name": "AccessManagedInvalidAuthority",
    "type": "error"
  },
  {
    "inputs": [
      { "internalType": "address", "name": "caller", "type": "address" },
      { "internalType": "uint32", "name": "delay", "type": "uint32" }
    ],
    "name": "AccessManagedRequiredDelay",
    "type": "error"
  },
  {
    "inputs": [
      { "internalType": "address", "name": "caller", "type": "address" }
    ],
    "name": "AccessManagedUnauthorized",
    "type": "error"
  },
  {
    "inputs": [
      { "internalType": "address", "name": "target", "type": "address" }
    ],
    "name": "AddressEmptyCode",
    "type": "error"
  },
  {
    "inputs": [
      { "internalType": "address", "name": "implementation", "type": "address" }
    ],
    "name": "ERC1967InvalidImplementation",
    "type": "error"
  },
  { "inputs": [], "name": "ERC1967NonPayable", "type": "error" },
  { "inputs": [], "name": "EmptyDescription", "type": "error" },
  { "inputs": [], "name": "EmptyImageCID", "type": "error" },
  { "inputs": [], "name": "EmptyLabel", "type": "error" },
  { "inputs": [], "name": "EmptyName", "type": "error" },
  { "inputs": [], "name": "FailedInnerCall", "type": "error" },
  { "inputs": [], "name": "InvalidBodyPosition", "type": "error" },
  { "inputs": [], "name": "InvalidCategory", "type": "error" },
  { "inputs": [], "name": "InvalidCategorySub", "type": "error" },
  { "inputs": [], "name": "InvalidFeeNumerator", "type": "error" },
  { "inputs": [], "name": "InvalidId", "type": "error" },
  { "inputs": [], "name": "InvalidInitialization", "type": "error" },
  { "inputs": [], "name": "InvalidLengths", "type": "error" },
  { "inputs": [], "name": "InvalidReceiver", "type": "error" },
  { "inputs": [], "name": "InvalidSetName", "type": "error" },
  { "inputs": [], "name": "InvalidTier", "type": "error" },
  { "inputs": [], "name": "InvalidTrim", "type": "error" },
  { "inputs": [], "name": "NotAuthorized", "type": "error" },
  { "inputs": [], "name": "NotInitializing", "type": "error" },
  { "inputs": [], "name": "UUPSUnauthorizedCallContext", "type": "error" },
  {
    "inputs": [
      { "internalType": "bytes32", "name": "slot", "type": "bytes32" }
    ],
    "name": "UUPSUnsupportedProxiableUUID",
    "type": "error"
  },
  { "inputs": [], "name": "WearableContractAlreadySet", "type": "error" },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "address",
        "name": "authority",
        "type": "address"
      }
    ],
    "name": "AuthorityUpdated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "uint64",
        "name": "version",
        "type": "uint64"
      }
    ],
    "name": "Initialized",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "templateId",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "string",
        "name": "name",
        "type": "string"
      }
    ],
    "name": "TemplateRegistered",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "implementation",
        "type": "address"
      }
    ],
    "name": "Upgraded",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "UPGRADE_INTERFACE_VERSION",
    "outputs": [{ "internalType": "string", "name": "", "type": "string" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "authority",
    "outputs": [{ "internalType": "address", "name": "", "type": "address" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint16", "name": "bodyPositionId", "type": "uint16" }
    ],
    "name": "bodyPositionToString",
    "outputs": [{ "internalType": "string", "name": "", "type": "string" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "bodyPositions",
    "outputs": [{ "internalType": "string[]", "name": "", "type": "string[]" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "bodyPositionsCount",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "categories",
    "outputs": [{ "internalType": "string[]", "name": "", "type": "string[]" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "categoriesCount",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint16", "name": "categorySubId", "type": "uint16" }
    ],
    "name": "categorySubToString",
    "outputs": [{ "internalType": "string", "name": "", "type": "string" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "categorySubs",
    "outputs": [{ "internalType": "string[]", "name": "", "type": "string[]" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "categorySubsCount",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint16", "name": "categoryId", "type": "uint16" }
    ],
    "name": "categoryToString",
    "outputs": [{ "internalType": "string", "name": "", "type": "string" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "deleteDefaultRoyalty",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "templateId", "type": "uint256" },
      { "internalType": "uint256", "name": "serialNumber", "type": "uint256" },
      { "internalType": "uint256", "name": "parentId", "type": "uint256" }
    ],
    "name": "generateTokenURI",
    "outputs": [{ "internalType": "string", "name": "", "type": "string" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "templateId", "type": "uint256" }
    ],
    "name": "getCurrentSerialNumber",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "templateId", "type": "uint256" }
    ],
    "name": "getTemplate",
    "outputs": [
      {
        "components": [
          { "internalType": "string", "name": "name", "type": "string" },
          { "internalType": "string", "name": "imageCID", "type": "string" },
          { "internalType": "string", "name": "description", "type": "string" },
          { "internalType": "uint16", "name": "setName", "type": "uint16" },
          { "internalType": "uint16", "name": "trim", "type": "uint16" },
          { "internalType": "uint16", "name": "tier", "type": "uint16" },
          {
            "internalType": "uint16",
            "name": "bodyPosition",
            "type": "uint16"
          },
          { "internalType": "uint16", "name": "category", "type": "uint16" },
          { "internalType": "uint16", "name": "categorySub", "type": "uint16" }
        ],
        "internalType": "struct TemplateRegistry.Template",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getWearableAddress",
    "outputs": [{ "internalType": "address", "name": "", "type": "address" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "templateId", "type": "uint256" }
    ],
    "name": "increaseSerialNumber",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "initialAuthority",
        "type": "address"
      }
    ],
    "name": "initialize",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "isConsumingScheduledOp",
    "outputs": [{ "internalType": "bytes4", "name": "", "type": "bytes4" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "proxiableUUID",
    "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "templateId", "type": "uint256" },
      {
        "components": [
          { "internalType": "string", "name": "name", "type": "string" },
          { "internalType": "string", "name": "imageCID", "type": "string" },
          { "internalType": "string", "name": "description", "type": "string" },
          { "internalType": "uint16", "name": "setName", "type": "uint16" },
          { "internalType": "uint16", "name": "trim", "type": "uint16" },
          { "internalType": "uint16", "name": "tier", "type": "uint16" },
          {
            "internalType": "uint16",
            "name": "bodyPosition",
            "type": "uint16"
          },
          { "internalType": "uint16", "name": "category", "type": "uint16" },
          { "internalType": "uint16", "name": "categorySub", "type": "uint16" }
        ],
        "internalType": "struct TemplateRegistry.Template",
        "name": "template",
        "type": "tuple"
      },
      {
        "components": [
          { "internalType": "address", "name": "receiver", "type": "address" },
          {
            "internalType": "uint96",
            "name": "royaltyFraction",
            "type": "uint96"
          }
        ],
        "internalType": "struct TemplateRegistry.RoyaltyInfo",
        "name": "_royaltyInfo",
        "type": "tuple"
      },
      {
        "internalType": "uint256",
        "name": "startSerialNumber",
        "type": "uint256"
      }
    ],
    "name": "registerTemplate",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256[]",
        "name": "templateIds",
        "type": "uint256[]"
      },
      {
        "components": [
          { "internalType": "string", "name": "name", "type": "string" },
          { "internalType": "string", "name": "imageCID", "type": "string" },
          { "internalType": "string", "name": "description", "type": "string" },
          { "internalType": "uint16", "name": "setName", "type": "uint16" },
          { "internalType": "uint16", "name": "trim", "type": "uint16" },
          { "internalType": "uint16", "name": "tier", "type": "uint16" },
          {
            "internalType": "uint16",
            "name": "bodyPosition",
            "type": "uint16"
          },
          { "internalType": "uint16", "name": "category", "type": "uint16" },
          { "internalType": "uint16", "name": "categorySub", "type": "uint16" }
        ],
        "internalType": "struct TemplateRegistry.Template[]",
        "name": "templates",
        "type": "tuple[]"
      },
      {
        "components": [
          { "internalType": "address", "name": "receiver", "type": "address" },
          {
            "internalType": "uint96",
            "name": "royaltyFraction",
            "type": "uint96"
          }
        ],
        "internalType": "struct TemplateRegistry.RoyaltyInfo[]",
        "name": "_royaltyInfos",
        "type": "tuple[]"
      },
      {
        "internalType": "uint256[]",
        "name": "startSerialNumbers",
        "type": "uint256[]"
      }
    ],
    "name": "registerTemplateBatch",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "templateId", "type": "uint256" }
    ],
    "name": "resetTemplateRoyalty",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "templateId", "type": "uint256" },
      { "internalType": "uint256", "name": "salePrice", "type": "uint256" }
    ],
    "name": "royaltyInfo",
    "outputs": [
      { "internalType": "address", "name": "", "type": "address" },
      { "internalType": "uint256", "name": "", "type": "uint256" }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "address", "name": "newAuthority", "type": "address" }
    ],
    "name": "setAuthority",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint16", "name": "bodyPositionId", "type": "uint16" },
      { "internalType": "string", "name": "bodyPosition", "type": "string" }
    ],
    "name": "setBodyPosition",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "string[]",
        "name": "bodyPositions_",
        "type": "string[]"
      },
      { "internalType": "uint16", "name": "startId", "type": "uint16" }
    ],
    "name": "setBodyPositions",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "string[]", "name": "categories_", "type": "string[]" },
      { "internalType": "uint16", "name": "startId", "type": "uint16" }
    ],
    "name": "setCategories",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint16", "name": "categoryId", "type": "uint16" },
      { "internalType": "string", "name": "category", "type": "string" }
    ],
    "name": "setCategory",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint16", "name": "categorySubId", "type": "uint16" },
      { "internalType": "string", "name": "categorySub", "type": "string" }
    ],
    "name": "setCategorySub",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "string[]",
        "name": "categorySubs_",
        "type": "string[]"
      },
      { "internalType": "uint16", "name": "startId", "type": "uint16" }
    ],
    "name": "setCategorySubs",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "address", "name": "receiver", "type": "address" },
      { "internalType": "uint96", "name": "feeNumerator", "type": "uint96" }
    ],
    "name": "setDefaultRoyalty",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [{ "internalType": "uint16", "name": "setId", "type": "uint16" }],
    "name": "setNameToString",
    "outputs": [{ "internalType": "string", "name": "", "type": "string" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "setNames",
    "outputs": [{ "internalType": "string[]", "name": "", "type": "string[]" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "setNamesCount",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint16", "name": "setId", "type": "uint16" },
      { "internalType": "string", "name": "setName", "type": "string" }
    ],
    "name": "setSetName",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "string[]", "name": "setNames_", "type": "string[]" },
      { "internalType": "uint16", "name": "startId", "type": "uint16" }
    ],
    "name": "setSetNames",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint256", "name": "templateId", "type": "uint256" },
      { "internalType": "address", "name": "receiver", "type": "address" },
      { "internalType": "uint96", "name": "feeNumerator", "type": "uint96" }
    ],
    "name": "setTemplateRoyalty",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint16", "name": "tierId", "type": "uint16" },
      { "internalType": "string", "name": "tier", "type": "string" }
    ],
    "name": "setTier",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "string[]", "name": "tiers_", "type": "string[]" },
      { "internalType": "uint16", "name": "startId", "type": "uint16" }
    ],
    "name": "setTiers",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint16", "name": "trimId", "type": "uint16" },
      { "internalType": "string", "name": "trim", "type": "string" }
    ],
    "name": "setTrim",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "string[]", "name": "trims_", "type": "string[]" },
      { "internalType": "uint16", "name": "startId", "type": "uint16" }
    ],
    "name": "setTrims",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "contract Wearable",
        "name": "wearable_",
        "type": "address"
      }
    ],
    "name": "setWearableContract",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint16", "name": "tierId", "type": "uint16" }
    ],
    "name": "tierToString",
    "outputs": [{ "internalType": "string", "name": "", "type": "string" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "tiers",
    "outputs": [{ "internalType": "string[]", "name": "", "type": "string[]" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "tiersCount",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "uint16", "name": "trimId", "type": "uint16" }
    ],
    "name": "trimToString",
    "outputs": [{ "internalType": "string", "name": "", "type": "string" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "trims",
    "outputs": [{ "internalType": "string[]", "name": "", "type": "string[]" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "trimsCount",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newImplementation",
        "type": "address"
      },
      { "internalType": "bytes", "name": "data", "type": "bytes" }
    ],
    "name": "upgradeToAndCall",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  }
]
